export default __webpack_public_path__ + "static/media/welcomingdeath.59c41fa4.png";